import { cva } from '@portal/styled-system/css'

export const reasonButtonRecipe = cva({
    base: {
        width: 'full',
        display: 'flex',
        alignItems: 'center',
        borderStyle: 'none', // reset
        outline: 'none', // reset
        backgroundColor: 'transparent', // reset
        gap: '2.5',
        borderRadius: 'medium',
        paddingX: '3',
        paddingY: '2',
        color: 'gray-v2.900',
        fontFamily: 'notoSans',
        textStyle: 'header-five',
        fontWeight: 'normal',
        _hover: {
            color: 'cyan-v2.800',
            backgroundColor: 'cyan-v2.100',
        },
        _active: {
            color: 'cyan-v2.900',
            backgroundColor: 'cyan-v2.300',
        },
        _focusVisible: {
            boxShadow: '[0 0 0 0.2rem var(--shadow-color)]',
            boxShadowColor: 'cyan-v2/25',
        },
    },
})
